module.exports = "<mat-progress-bar id=\"progress\" mode=\"indeterminate\"></mat-progress-bar>\n"